module.exports = __webpack_public_path__ + "static/media/manage-categories.ae3b2606.svg";